import { gql } from "@apollo/client";

export const UPDATE_PRODUCT_IMAGE_POSITION = gql`
  mutation UpdateProductImagePosition($input: UpdateProductImageInput!) {
    updateProductImagePosition(input: $input) {
      id
    }
  }
`;
